import { useEffect, Component } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis } from "@/lib/lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeRibbon from "@/components/Marquee";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Services from "@/components/Services";
import Advantage from "@/components/Advantage";
import Testimonials from "@/components/Testimonials";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] font-mono text-sm text-[#4A5361]">
          Something went wrong — please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => initLenis(), []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen bg-[#F8FAFC] text-[#0F141A] antialiased">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <MarqueeRibbon />
          <Problem />
          <Solution />
          <Services />
          <Advantage />
          <Testimonials />
          <About />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="light" richColors closeButton />
      </div>
    </ErrorBoundary>
  );
}
